import { createFileRoute } from "@tanstack/react-router"
import { usePageTitle } from "@/contexts/PageTitleContext.tsx"
import { useEffect } from "react"
import {
  Accordion,
  AccordionContent,
  AccordionTrigger,
  AccordionItem,
} from "@/components/ui/accordion.tsx"
import { getStoredLocale } from "@/lib/utils.ts"

export const Route = createFileRoute("/_protected/faq")({
  ssr: false,
  component: RouteComponent,
})

const faqListAr = [
  {
    id: 1,
    question: "هل هناك أي تكلفة للتسجيل في الموقع ؟",
    answer: "كلا، التسجيل وإرسال المقترحات متاحين بشكل مجاني.",
  },
  {
    id: 2,
    question: "ما هي خطوات التسجيل على المنصة؟",
    answer:
      "اولا، عليك تسجيل حساب جديد من خلال النقر على اشتراك، حيث يمكنك أن تشترك من خلال حساب جوجل الخاص بك أو عن طريق ملئ معلومات البريد الإلكتروني وكلمة المرور. بعد الاشتراك سيتم طلب تفعيل البريد الإلكتروني من خلال النقر على الرابط المرسل إلى عنوان البريد المسجل لدى إيجاب. عندها سوف يصبح بإمكانك الدخول إلى المنصة لإكمال باقي المعلومات المطلوبة لبدء كتابة المقترحات الخاصة بك",
  },
  {
    id: 3,
    question: "لقد سجلت الدخول ولم يتم السماح لي بإرسال مقترحات ؟",
    answer:
      "يجب ملء البيانات كافة المطلوبة في قائمة الاعدادات حتى تصبح خاصية إرسال المقترحات متاحة لك",
  },
  {
    id: 4,
    question: "تم ملء بيانات الحساب ولم استطع تسليم مقترح ؟",
    answer:
      "يجب ملء الخانات كافة في قسم الإعدادات: يجب تسجيل بيانات الحساب والبيانات الشخصية بالإضافة إلى البيانات المهنية.",
  },
  {
    id: 5,
    question: "هل يمكن طرح أكثر من مقترح واحد ؟",
    answer:
      "نعم، يمكن تقديم عدة مقترحات. ولكن يتم إرسال كل مقترح على حدا. لا يجوز جمع أكثر من مقترح داخل المقترح الواحد.",
  },
  {
    id: 6,
    question: "ما هي المدة المتوقعة للرد على مقترحي؟",
    answer:
      "نسعى للرد على المقترحات خلال أسبوعين من تسليمها ولكن في بعض الأحيان قد تطول المدة عن ذلك في حالة استقبالنا العديد من المقترحات في نفس الوقت.",
  },
  {
    id: 7,
    question: "كيف أعرف إذا تم قبول المقترح أو رفضه ؟",
    answer:
      'في حال القبول أو الرفض سوف تتلقى/ين ردا على المقترح من فريق العمل. كما سيصلك إخطار عبر الايميل. ولذا من المهم التأكد أن كافة المراسلات من إيجاب تصلك. الرجاء التأكد من أن المراسلات لا تذهب إلى ملف ال"سبام" في بريدك الالكتروني. في أغلب الأوقات، قبل رفض أو قبول المقترح سيحتاج الفريق لمعلومات أكثر ولذا نرجو الدخول على حسابك بشكل يومي والتأكد من الرد على أية استفسارات حتى لا يتم تأجيل العمل على مقترحك بدون داع. نتوقع من الصحفيين الرد على أسئلتنا خلال الوقت المحدد من قبل محرر إيجاب والذي سيتم توضيحه في خانة التعليقات. كما سيصلك تنويه على البريد الالكتروني عند إرسال الفريق أي أسئلة لك عن مقترحك.',
  },
  {
    id: 8,
    question: "ما هي الخطوات التي تلي قبول المقترح ؟",
    answer:
      "بعد قبول المقترح يتم عرضه على المنصات الإعلامية المختلفة وسيتم إعلامك فور إبداء أي من المنصات الرغبة في شرائه. لتأكيد موافقتك على العرض وموعد التسليم. قبول مقترحك لايعني أنه تم استكتابه. وبالتالي لا تيدأ(ي) العمل على القصة حتى يعلمك الفريق رسميا ببيع المقترح من خلال البريد الإلكتروني. بعد قبولك العرض المقدم من الوسيلة الإعلامية، تقوم(ي) بإنتاج المادة الصحفية التي ستنشر باسمك. بعد ذلك تقوم إيجاب باستلام المبلغ المقدم من الوسيلة الإعلامية مقابل القصة الصحفية واستقطاع نسبة إيجاب المشار إليها في قواعد استخدام المنصة قبل تحويل باقي المبلغ لك.",
  },
  {
    id: 9,
    question: "هل يمكنني تسليم مقترحات أخرى بعد أن تم رفض مقترحي؟",
    answer:
      "بالطبع. عند رفض أي مقترح سيعلمك الفريق بالأسباب ونتوقع منك أن تراع هذه الأسباب في مقترحاتك القادمة. أحد أهداف إيجاب هو مساعدة الصحفيين المحليين على تطوير مهاراتهم ومنها مهارة كتابة المقترحات. واكتساب أي مهارة جديدة يحتاج إلى وقت لذا نأمل ألا تيأس(ي) إن تم رفض أكثر من مقترح من قبلك.",
  },
  {
    id: 10,
    question: "بأي لغة يمكن تقديم المقترحات؟",
    answer: "يمكن تقديم المقترح بأي من اللغتين العربية أو الإنجليزية.",
  },
  {
    id: 11,
    question: "هل يقدم الموقع خدمة الترجمة؟",
    answer:
      "نعم تقدم المنصة خدمة الترجمة المحترفة للمقترحات و القصص الصحفية التي يتم إنتاجها من خلالنا وتزيد نسبة إيجاب من عائد القصة لقاء هذه الخدمة.",
  },
  {
    id: 12,
    question: "هل تقبل إيجاب مقترحات لمقالات فقط؟",
    answer:
      "لا، نقبل مقترحات لقصص صحفية يتم إنتاجها بكل الأشكال: مكتوبة، مصورة، الخ. وبالفعل تم نشر تقارير تلفزيونية وقصص مصورة من خلا إيجاب بالإضافة إلى الموضوعات المكتوبة.",
  },
  {
    id: 13,
    question: "هل يمكن إختيار المنصة التي أريد النشر من خلالها ؟",
    answer:
      "لا يمكن للصحفي/ة إختيار المنصة المحتملة للنشر عليها ، إنما يمكن إستثناء منصات لا يرغب بالنشر عليها. هناك سؤال عن ذلك في صفحة تقديم المقترحات يتيح لك كتابة المنصات التي لا ترغب في عرض مقترحك عليها.",
  },
  {
    id: 14,
    question: "ما هي وسائل الإعلام أو منصات النشر التي تتعامل معها إيجاب؟",
    answer:
      "إيجاب تتعامل مع المنصات العالمية والإقليمية المهتمة بنشر أخبار وموضوعات من منطقة الشرق الأوسط وأفريقيا.",
  },
  {
    id: 15,
    question: "هل تتعاملون مع منصات محلية؟",
    answer: "لا، نتعامل فقط مع منصات إعلامية دولية أو إقليمية.",
  },
  {
    id: 16,
    question:
      "هل يجب تقديم مقترح يتعلق بالبلد الذي أنتمي إليه أو أعيش به/أقطنه؟",
    answer:
      "نعم ، إنطلاقا من مبدأ ساكن المكان أدرى به ولدعم الصحفيين المحليين ، يجب على الصحفي/ة تقديم مقترح من البلد المتواجد به أو البلد الذي ينتمي إليه. بمعنى إن كنت مثلا مصريا تعيش في لندن، فيمكنك إرسال مقترحات عن مصر أو عن الجالية العربية في لندن مثلا.",
  },
  {
    id: 17,
    question: "هل تقبل إيجاب فقط مقترحات صحافة الحلول؟",
    answer:
      "تتخصص إيجاب في صحافة الحلول ولكن في بعض الأحيان نقبل مقترحات أخرى. الحالات التي يتم فيها قبول مقترحات لا تندرج في فئة صحافة الحلول: أن يكون المقترح عن قصة جديدة لم يتناولها الإعلام من قبل وتوضح شيئ غير معروف عن هذا المجتمع أو البلد. أن يتم طلب مقترحات عن موضوعات لا تمت لصحافة الحلول من قبل وسيلة إعلامية نتعامل معها. في هذه الحالة سوف يتم إعلام الصحفيين المسجلين على المنصة من خلال الإيميل عن هذا الطلب.",
  },
  {
    id: 18,
    question:
      "هل يمكنني تقديم مقترحات لقصص تم نشرها من قبل في منصات إقليمية أو دولية؟",
    answer:
      "لا، إيجاب تعطي أولوية لقصص صحفية جديدة لم يتم تناولها من قبل. نحن ضد إعادة تدوير القصص الصحفية التي سرعان ما ستندثر مع اتساع نطاق استخدام الذكاء الاصطناعي. ولذا إن تم تناول قصتك المقترحة في الإعلام العالمي أو الإقليمي سيتم رفض مقترحك. ولكن إن اقتصرت تغطية القصة على الإعلام المحلي فلا مشكلة في ذلك ولكن نطلب منك تضمين روابط لهذه التغطية مع مقترحك.",
  },
  {
    id: 19,
    question: "هل يمكنني عرض نفس المقترح الذي قدمته لايجاب على منصات أخرى ؟",
    answer:
      "لا، لايمكنك تقديم نفس المقترح أو مقترح آخر لنفس القصة أو قصة مشابهة لأي منصات أخرى إلا في حالة رفض المقترح من قبل إيجاب. وفقا لشروط وقواعد استخدام المنصة التي توافق عليها بتسجيلك على المنصة فإن لإيجاب الحق الحصري على المقترحات والقصص الصحفية التي يتم تسليمها للمنصة. قواعد وشروط استخدام المنصة وخدمة إيجاب متاحة على المنصة.",
  },
  {
    id: 20,
    question:
      "هل يمكنني نشر القصة التي تم بيعها عن طريق إيجاب على مواقع إعلامية أخرى؟",
    answer:
      "لا، لأن إيجاب لها حق حصري على كل المحتوى المقدم إليها من قبل الصحفي. يرجى مراجعة إجابة السؤال السابق لمزيد من التفاصيل.",
  },
  {
    id: 21,
    question: "ما هي المزايا التي أحصل عليها بالتسجيل على منصة إيجاب؟",
    answer:
      "تطوير مهاراتك الصحفية من خلال التعلم من و الحصول على فرصة التوجيه المباشر من صحفيين مخضرمين عملوا في أكبر الوسائل الإعلامية مثل البي بي سي وبلومبرج ووول ستريت جورنال. تطوير سيرتك الذاتية المهنية من خلال النشر في كبرى المنصات الإعلامية مما يساعدك على تحسين فرصك في الحصول على فرص وظيفية أفضل. الحصول على عائد مادي عادل لعملك الصحفي.",
  },
  {
    id: 22,
    question: "مع من يمكنني التواصل إن كان لدي أية استفسارات؟",
    answer:
      "للاستفسارات التحريرية يمكنك التواصل مع المحررين من خلال خاصية الرسائل على المنصة. لأي أمور تقنية يرجو مراسلة tech@egab.co لأي استفسارات مالية نرجو مراسلة accounting@egab.co لأي استفسارات قبل التسجيل على المنصة نرجو مراسلة enquiries@egab.co لأي استفسارات بعد التسجيل على المنصة نرجو مراسلة clientsupport@egab.co",
  },
  {
    id: 23,
    question: "هل يمكنني إلغاء حسابي من على منصة إيجاب؟",
    answer:
      "نعم يمكنك محو حسابك من على المنصة ولكن نرجو التنويه أنه في حالة تسليمك أي مقترحات لم يتم البت فيها أو تم قبولها، يكون للمنصة الحق الحصري عليها. أي أنه لا يمكنك عرضها على أي منصات أخرئ بدون إيجاب. فقط يحق لك ذلك في حالة رفض المقترح من قبل إيجاب كما هو موضح في قواعد وشروط استخدام المنصة.",
  },
]

const faqList = [
  {
    id: 1,
    answer:
      "No, signing up on the platform and submission of pitches are free of charge. You also receive feedback on your pitch - even the rejected ones - for free.",
    question: "Is there any cost to register on the platform?",
  },
  {
    id: 2,
    answer:
      "First, you have to create a new account by clicking on sign up, where you can register through your Google account or by filling in your email and password information. After that, you will be requested to verify your email address by clicking on the link sent to the email address registered with Egab. Once you do that, you will be able to access the platform to complete setting up your account so that you can start pitching your stories to Egab.",
    question: "What are the steps to sign up on the platform?",
  },
  {
    id: 3,
    answer:
      "You must fill in all the required data in the settings section in order to be able to create pitches on the platform.",
    question: "I have signed up but I still cannot create any pitches?",
  },
  {
    id: 4,
    answer:
      "All fields in the Settings section must be filled in: account data, personal data and professional data must all be completed.",
    question:
      "The account information was filled out, and I could not create a pitch?",
  },
  {
    id: 5,
    answer:
      "Yes, several pitches can be submitted. But each pitch must be sent separately. It is not permissible to combine more than one pitch within a single submission.",
    question: "Is it possible to submit more than one pitch?",
  },
  {
    id: 6,
    answer:
      "We seek to respond to pitches as soon as possible but we can’t set an exact timeframe as this depends on several factors like receiving many pitches at the same time. If your pitch is urgent, i.e. is pegged to a forthcoming event, please indicate that in the headline so the team can prioritize reviewing it.",
    question: "What is the expected time for a response to my proposal?",
  },
  {
    id: 7,
    answer:
      'Whether your pitch is accepted or rejected , you will receive a response from Egab’s team. You will also receive a notification via e-mail. Therefore, it is important to ensure that all correspondence from Egab reaches you. Please make sure that emails from Egab not go to the "spam" folder of your e-mail. Most of the time, before rejecting or accepting a pitch, the team will need more information. Therefore, please log into your account on a daily basis and make sure to respond to any inquiries so that work on your proposal is not unnecessarily delayed. We expect journalists to respond to our questions within the time specified by the Egab editor, which will be indicated in the comments section. You will also receive an email notification when the team sends you any questions about your pitch.',
    question: "How do I know if the pitch has been accepted or rejected?",
  },
  {
    id: 8,
    answer:
      "After approving your pitch and editing the final version, it will be circulated to the various media outlets we work with and you will be notified as soon as any of the platforms commissions it in order to confirm your acceptance of the offer and the submission date. Acceptance of your pitch does not mean that it has been commissioned. Therefore, do not start working on the story until the team has officially notified you of the commissioning offer through email. After accepting the offer submitted by the media outlet, you will produce the story that will be published under your name. After that, Egab receives the financial compensation provided by the media outlet in exchange for the story, deducts its commission and then transfers the rest of the money to your bank account.",
    question: "What are the steps that follow the acceptance of the pitch?",
  },
  {
    id: 9,
    answer:
      "When we reject any pitch, the team will inform you of the reasons. We expect you to take these reasons into account when drafting your next pitch. One of Egab's goals is to help local journalists develop their skills, including pitch writing. Acquiring any new skill takes time, so we hope that you will not despair if we reject more than one pitch.",
    question: "Can I submit other pitches after my pitch has been rejected?",
  },
  {
    id: 10,
    answer: "The pitches can be submitted in Arabic, English or French.",
    question: "In what language can the pitch be submitted?",
  },
  {
    id: 11,
    answer:
      "Yes, the platform provides a professional translation service for pitch and stories that are produced through us. In this case, Egab’s commission increases.",
    question:
      "Does Egab provide translation services for the pitches & stories submitted through it?",
  },
  {
    id: 12,
    answer:
      "No, Egab accepts pitches for stories to be produced in all formats: Text, Video, Radio, etc.",
    question: "Does Egab only accept pitches for text formats?",
  },
  {
    id: 13,
    answer:
      "The journalist cannot choose the possible platform to publish on, but he/she can exclude platforms on which he / she does not wish to publish. There is a question about this on the create pitches page that allows you to type in the names of the media outlets that you do not wish to send your pitch to.",
    question: "Can I choose the platform through which I want to publish?",
  },
  {
    id: 14,
    answer:
      "Egab works with global and regional media outlets interested in publishing news and stories from the Middle East and Africa.",
    question: "What are the media outlets that Egab deal with?",
  },
  {
    id: 15,
    answer:
      "No, we only pitch stories to regional and international media outlets.",
    question: "Do you work with local media outlets?",
  },
  {
    id: 16,
    answer:
      "Yes, we believe that locals know their communities best and to align with our mission to support local journalists, the journalist must submit a proposal from the country in which he is located or the country to which he belongs. In other words, if you are, for example, an Egyptian living in London, you can send pitches about Egypt or the Arab community in London.",
    question:
      "Do I have to submit a proposal idea related to the country in which I live/reside?",
  },
  {
    id: 17,
    answer:
      "Egab specializes in solutions journalism, but sometimes we accept other pitches in the following cases: The pitch is about a new story that has not been covered by the media before and that explains something unknown about this society or country. The pitch is submitted in response to a call for pitches that Egab circulated on behalf of a media outlets looking for non-sojo stories. In this case, journalists registered on the platform will be notified via e-mail about this request.",
    question: "Does Egab only accept solutions journalism (sojo) pitches?",
  },
  {
    id: 18,
    answer:
      "No, Egab gives priority to original stories that have not been covered before. We are against the recycling of journalistic stories that will quickly become obsolete with the widespread use of artificial intelligence. Therefore, if your proposed story is covered in global or regional media, your pitch will be rejected. However, if the coverage of the story is limited to local media, you can pitch the story but we ask that you include links to this local coverage along with your pitch.",
    question:
      "Can I submit pitches that have already been published in regional or international platforms?",
  },
  {
    id: 19,
    answer:
      "No, you cannot submit the same pitch or a similar pitch to any other platform unless Egab rejects your pitch. In accordance with the terms and conditions of using the platform, which you agree to by signing up on the platform, we have the exclusive right to pitches and stories that are submitted to the platform. The rules and conditions for using the platform are available for you to read on the platform.",
    question:
      "Can I send the same pitch I submitted to Egab to other outlets or platforms?",
  },
  {
    id: 20,
    answer:
      "No, Egab has an exclusive right to all content submitted to it by the journalist. Please review the answer to the previous question for more details.",
    question:
      "Can I publish the same or a very similar story to the one that was commissioned through Egab on other outlets ?",
  },
  {
    id: 21,
    answer:
      "Developing your journalism skills by learning and receiving guidance directly from veteran international journalists who worked for top media outlets like the BBC, Bloomberg and the Wall Street Journal. Enhancing your career prospects by filling your CV with bylines in top media outlets. Getting paid fairly for your work.",
    question: "What are the benefits of signing up on Egab?",
  },
  {
    id: 22,
    answer:
      "For editorial queries, you can message the relevant editor directly via the messaging feature on the platform. For technical queries, email tech@egab.co For financial queries, email accounting@egab.co For general queries before signing up on the platform, email enquiries@egab.co For general queries after signing up on the platform, email clientsupport@egab.co",
    question: "Who can I contact if I have any further queries?",
  },
  {
    id: 23,
    answer:
      "Yes, you can. But if there are any pending pitches or pitches that we have accepted, Egab continues to have exclusive rights to them. In other words, you cannot send the pitches you submitted to Egab to any other outlet or platform, unless the pitch has been clearly rejected by Egab.",
    question: "Can I delete my account on Egab?",
  },
]

function RouteComponent() {
  const { setTitle } = usePageTitle()
  const locale = getStoredLocale()

  useEffect(() => {
    setTitle(locale === "ar" ? "الأسئلة المتكررة" : "FAQ")
  }, [setTitle])

  return (
    <div className="w-full">
      <Accordion defaultValue={["faq_1"]} className="w-full">
        {(locale === "ar" ? faqListAr : faqList).map((faq) => (
          <AccordionItem key={`faq_${faq.id}`} value={`faq_${faq.id}`}>
            <AccordionTrigger className="text-lg">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent>{faq.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}
